/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
import TwoFactorUpgradeBaseComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/upgrade/base';
export default class TwoFactorModalUpgradeBaseComponent extends TwoFactorUpgradeBaseComponent {
  constructor() {
    super(...arguments);
  }

  // override TwoFactorUpgradeBaseComponent#hideUseAnotherMethodButton with email-less version
  // the normal version is used in login and has email 2fa as fallback, but modal does not have the use case
  get hideUseAnotherMethodButton() {
    if (this.multipassfeClient.twoFactorDetails.filter(x => !x.email).length > 1) {
      return false;
    }
    if (this.isSmsMethod && this.multipassfeClient.canUseVoice) {
      return false;
    }
    return true;
  }

  /**
   * Override TwoFactorUpgradeBaseComponent#handleMultipassError w/ two_factor_modal copy
   */
  handleMultipassError(error) {
    switch (error) {
      case 'BLOCKED_SMS_NUMBER':
        this.smsBlockedOptInMessagingModalOpen = true;
        break;
      case 'INVALID_ALIAS':
      case 'INVALID_CREDENTIALS':
        this.error = this.intl.t(this.tPrefix + 'two_factor_modals.upgrade.generic.errors.invalid_verification_code');
        break;
      case 'TEMPORARY_LOCKOUT':
        this.error = this.intl.t(this.tPrefix + 'two_factor_modals.upgrade.generic.errors.temporary_lockout');
        break;
      default:
        this.error = this.intl.t(this.tPrefix + 'two_factor_modals.upgrade.generic.errors.unknown');
    }
  }
}